import { Component, OnInit, EventEmitter, Output, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UploadPictureComponent } from '../shared/upload-picture.component';
import { FormHelperService } from '../core/services/form-helper.service';
import { FilterService } from '../core/services/filter.service';
import { DropdownValue } from '../shared/dropdown.model';
import { BrandLogosService } from '../brand-logos/brand-logos.service';
import { BrandModel } from '../shared/brand.model';
import { BrandLogo } from '../brand-logos/brand-logo.model';
import { BrandPreidService } from './brand-preid.service';

@Component({
    moduleId: module.id,
    selector: 'brand-preid-modal',
    templateUrl: 'brand-preid-modal.component.html'
})

export class BrandPreIdModalComponent implements OnInit {
    newWindow: Window;
    brandIdField: number;
    brandLogoForm: FormGroup;
    headerText: string = "Create Brand Info";
    showDuplicateError: boolean = false;
    isLoading = false;
    private readonly modalId = "#brandPreIdModal";
    showUploadError: boolean = false;

    selectedBrand: string;
    brandsList: Array<BrandModel> = [];
    brandId?: number;
    brandLogosList: Array<BrandLogo> = [];
    brandLogoId?: number;
    brandInfoForm: FormGroup;
    showBrandOverlay: boolean = false;
    brandLogoSelected: boolean = false;
    mediaFile: string;

    @Output() brandPreIdDone: EventEmitter<any> = new EventEmitter<Event>();;
    @ViewChild("uploadPictureFromPc") uploadPictureFromPc: UploadPictureComponent

    constructor(private formBuilder: FormBuilder,
        private formHelperService: FormHelperService,
        private brandLogoService: BrandLogosService,
        private brandPreIdService: BrandPreidService,
        private filterItemsService: FilterService,
        private el: ElementRef) {
    }

    ngOnInit() {
        this.brandsList = this.filterItemsService.getBrands();

        this.brandLogoForm = this.formBuilder.group({
            brandNameField: ['', [Validators.required]],
            pictureFromPc: ['', []],
            pictureFromUrl: ['', []],
            adTitleField: ['', []],
            adDescriptionField: ['', []]
        });
    }

    onSaveChanges(event: any) {
        if (!this.brandLogoForm.valid)
            return;
        this.isLoading = true;
        let reader = new FileReader();
        //if logo was uploaded from pc
        if (this.uploadPictureFromPc.file) {
            let self = this;
            reader.onload = (function (theFile) {
                return function (e) {
                    let binaryString = e.target.result;
                    let imageFile = binaryString.replace(/^data:image\/[a-z]+;base64,/, "");
                    //if brand exists, add the new logo to it
                    let brand = self.brandsList.find(x => x.name == self.selectedBrand);
                    if (brand) {
                        if (self.brandId == null || self.brandId == 0) self.brandId = brand.id;
                        self.createBrandLogo(imageFile, null);
                    }
                    else {
                        //if brand is new, add both the brand and its logo
                        self.createBrandAndLogo(imageFile, null);
                    }
                };
            })(this.uploadPictureFromPc.file);
            reader.readAsDataURL(this.uploadPictureFromPc.file);
        }
        //if logo was selected from image search
        if (this.brandLogoForm.value.pictureFromUrl != null) {
            let self = this;
            //if brand exists, add the new logo to it
            let brand = self.brandsList.find(x => x.name == self.selectedBrand);
            if (brand) {
                if (self.brandId == null || self.brandId == 0) self.brandId = brand.id;
                this.createBrandLogo(null, self.brandLogoForm.value.pictureFromUrl);
            } else {
                //if brand is new, add both the brand and its logo
                this.createBrandAndLogo(null, self.brandLogoForm.value.pictureFromUrl);
            }
        }
    }

    private createBrandLogo(imageFromBase64: string, imageFromUrl: string) {
        let self = this;
        self.brandLogoService.createBrandLogo(self.brandId, imageFromBase64, imageFromUrl)
            .subscribe(response => {
                    $(self.modalId).modal('hide');
                    //save brand and logo info for ad
                    let result = response.json();
                    self.brandPreIdService.setIdentifiedAd(self.mediaFile, self.brandId, result.imageUrl, result.imageHeight, result.imageWidth, 
                        self.brandLogoForm.value.adTitleField, self.brandLogoForm.value.adDescriptionField)
                    .subscribe(resp => { }, e => { }, () => { self.isLoading = false; self.brandPreIdDone.emit(); });
                },
                () => { self.isLoading = false; },
                () => { self.isLoading = false; });
    }

    private createBrandAndLogo(imageFromBase64: string, imageFromUrl: string) {
        let self = this;
        self.brandLogoService.createBrandAndLogo(self.selectedBrand, imageFromBase64, imageFromUrl)
            .subscribe(response => {
                    $(self.modalId).modal('hide');
                    let result = response.json();
                    self.brandId = result.brandId;
                    //refresh list of brands in cache
                    self.brandLogoService.getBrands().subscribe(response => {
                        let brands = response.json();
                        self.filterItemsService.setBrands(brands);
                        self.brandsList = self.filterItemsService.getBrands();
                        //save brand and logo info for ad
                        self.brandPreIdService.setIdentifiedAd(self.mediaFile, self.brandId, result.imageUrl, result.imageHeight, result.imageWidth, 
                            self.brandLogoForm.value.adTitleField, self.brandLogoForm.value.adDescriptionField)
                        .subscribe(resp => { }, () => { }, () => { self.brandPreIdDone.emit(); });
                    }, () => { self.isLoading = false; }, () => { self.isLoading = false; });
                },
                () => { self.isLoading = false; },
                () => { self.isLoading = false; });
    }

    showAddNewBrandInfo(videoPlayerSource: string, selectedBrand: any, brandId?: number, adTitleField?: any, adDescriptionField?: any) {
        this.isLoading = false;
        this.headerText = "Create Brand Info";
        this.brandLogoForm.reset();
        if (this.uploadPictureFromPc)
            this.uploadPictureFromPc.reset();
        if (this.brandLogoForm.value.pictureFromUrl)
            this.brandLogoForm.value.pictureFromUrl = null;
        this.showUploadError = false;
        this.mediaFile = videoPlayerSource;
        if (selectedBrand != null)
            this.selectedBrand = selectedBrand.name;
        this.brandId = brandId;
        if (adTitleField != null)
            this.brandLogoForm.controls["adTitleField"].setValue(adTitleField);
        if (adDescriptionField != null)
            this.brandLogoForm.controls["adDescriptionField"].setValue(adDescriptionField);
        $(this.modalId).modal('show');
    }

    showErrorMessage(controlName: string, validator: string): boolean {
        return this.formHelperService.showErrorMessage(this.brandLogoForm, controlName, validator);
    }

    onUploadFromPc(name: any): void {
        this.brandLogoForm.controls["pictureFromPc"].setValue(name);
        if (name) {
            this.showUploadError = false;
            this.brandLogoSelected = true;
        }
        else
            this.showUploadError = true;
    }

    onBrandAutocompleteClicked(event) {
        let ng2Autocomplete = this.el.nativeElement.querySelectorAll("ng2-auto-complete");
        $(ng2Autocomplete).addClass('custom-autocomplete');
        //remove the selection from the previous brand and select the current brand
        let listOfBrands = $(ng2Autocomplete).find('ul li');
        let brand = this.selectedBrand;
        $(listOfBrands).each(function (i, e) {
            $(e).removeClass('selected');
            if (brand == $(e).text()) $(e).addClass('selected');
        });
    }

    // not in use
    onBrandValueChanged(item) {
        this.showBrandOverlay = true;
        this.brandLogosList = [];
        let found = this.brandsList.filter(x => x.name == item.name);
        if (found.length > 0) {
            this.brandId = item.id;
            // this.brandLogoService.getBrandLogosForBrand(this.brandId).subscribe(response => {
            //     let list = response.json();
            //     if (list) {
            //         for (let item of list) {
            //             this.brandLogosList.push(item);
            //         }
            //     } else {
            //         this.brandLogosList = [];
            //     }
            // }, () => { }, () => { this.showBrandOverlay = false; });
            this.showBrandOverlay = false;
        } else {
            this.brandLogosList = [];
            this.showBrandOverlay = false;
        }
    }

    keyDownFunction(event) {
        let found = this.brandsList.filter(x => x.name == this.selectedBrand);
        if (found.length <= 0) {
            this.showBrandOverlay = true;
            this.brandLogosList = [];
            this.showBrandOverlay = false;
        }
    }

    autocompleListFormatter(data: any): string {
        return `${data.name}`;
    }

    onClose() {
        this.selectedBrand = null;
        this.brandId = 0;
        this.brandLogosList = [];
        this.brandLogoId = null;
        this.brandLogoSelected = false;
    }

    onSearchLogoForBrand() {
        this.newWindow = window.open('', '_blank');
        this.newWindow.location.href = 'https://www.google.com/search?q=' + this.selectedBrand + '+imagesize:400x400&tbm=isch';
        this.brandLogoSelected = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/brand-preid/brand-preid-modal.component.ts